import React from "react";
import { Text } from "@showitinc/showit-wc";

import AnimationProperties from "../../../components/AnimationProperties";
import HoverProperties from "../shared/HoverProperties";
import AppConstants from "../../../constants/AppConstants";
import { TRANSITION_IN, TRANSITION_OUT } from "../../../constants/AnimationConstants";

const BlockPropertiesAnimation = ({ onPropUpdate, block, layout }) => {
  const _onAnimationChange = (propInfo) => {
    onPropUpdate && onPropUpdate(propInfo);
  };

  const blockProps = block.get(layout);
  const defaultHover = block.get("defaultHover");
  const trIn = blockProps.get(TRANSITION_IN);
  const trOut = blockProps.get(TRANSITION_OUT);

  return (
    <>
      <Text className="panel-subheading">Default Hover</Text>
      <HoverProperties
        hoverPropName="defaultHover"
        elementType="all"
        defaultType={AppConstants.HOVER_TYPE_PAGE}
        hover={defaultHover}
        showBlockDefault={false}
        onPropUpdate={_onAnimationChange}
      />
      <Text className="panel-subheading">Canvas In</Text>
      <AnimationProperties
        container={block}
        layout={layout}
        transitionType={TRANSITION_IN}
        tran={trIn}
        propPrefix={layout}
        showBlockDefault={false}
        defaultType={AppConstants.ANIMATION_TYPE_NONE}
        onPropUpdate={_onAnimationChange}
      />
      <Text className="panel-subheading">Canvas Out</Text>
      <AnimationProperties
        container={block}
        layout={layout}
        transitionType={TRANSITION_OUT}
        tran={trOut}
        propPrefix={layout}
        showBlockDefault={false}
        defaultType={AppConstants.ANIMATION_TYPE_NONE}
        onPropUpdate={_onAnimationChange}
      />
    </>
  );
};

export default BlockPropertiesAnimation;
